import React from 'react';
import styled from 'styled-components';

import i18n from 'i18n';
import { fontRegular } from 'themes';

const Container = styled.div`
  background: white;
  width: 100vw;
  height: 100%;
  display: inline-block;
  max-width: calc(100% - 20px);
  padding: 10px;
  text-align: center;
  font-size: 16px;
  font-family: ${fontRegular};
`;

const Title = styled.div`
  margin-bottom: 24px;
  padding-top: 50%;

  div {
    margin-bottom: 12px;
  }
`;

const SearchAction = styled.div`
  margin-bottom: 12px;
  color: #00b0b9;
`;

const SearchRecommendations = ({
  recommendations = [],
  onSearch,
  noResults
}) => (
  <Container>
    <Title>
      {noResults && <div>{i18n('component.Search.noResults')()}</div>}
      {i18n('component.Search.defaultRecsText')()}
    </Title>
    {recommendations.map((recommendation) => (
      <SearchAction
        key={recommendation}
        onClick={() => onSearch(recommendation)}
      >
        {recommendation}
      </SearchAction>
    ))}
  </Container>
);

export default SearchRecommendations;
